const PAIN_POINTS = [
  {
    icon: 'ri-home-line',
    title: 'Not Getting Enough Buyer & Seller Leads?',
    body: 'You\'re a great agent but your pipeline is inconsistent. Most realtors struggle to generate a steady flow of qualified leads — not because of their skills, but because their ads aren\'t reaching the right people at the right time.',
    stat: '74% of real estate agents',
    statLabel: 'say lead generation is their #1 challenge',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Wasting Budget on Ads That Don\'t Convert?',
    body: 'You\'ve tried boosting listing posts or running Zillow ads, but the ROI just isn\'t there. Weak copy and wrong targeting drain your budget fast — leaving you with impressions but no appointments.',
    stat: '$7,400 avg.',
    statLabel: 'wasted per year on ineffective real estate advertising',
  },
  {
    icon: 'ri-time-line',
    title: 'No Time to Learn Digital Marketing?',
    body: 'You\'re showing homes, writing contracts, and managing clients. You don\'t have hours to master Facebook Ads Manager or write compelling listing copy. Marketing feels like a second career you never signed up for.',
    stat: '7+ hours/week',
    statLabel: 'lost trying to manage real estate ads manually',
  },
];

export default function RealEstatePainPoints() {
  return (
    <section className="py-20 lg:py-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-3">
            Sound Familiar?
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4 leading-tight">
            The Real Problems Real Estate Agents Face with Advertising
          </h2>
          <p className="text-base text-stone-400 max-w-xl mx-auto">
            You didn&apos;t get your license to become a marketer. But without great ads, your pipeline dries up.
            Here&apos;s what most agents deal with every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PAIN_POINTS.map((point) => (
            <div
              key={point.title}
              className="bg-white/5 border border-white/10 rounded-2xl p-7 flex flex-col gap-4 hover:bg-white/8 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-500/20 text-orange-400">
                <i className={`${point.icon} text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-white leading-snug">{point.title}</h3>
              <p className="text-sm text-stone-400 leading-relaxed flex-1">{point.body}</p>
              <div className="pt-4 border-t border-white/10">
                <span className="text-xl font-black text-orange-400">{point.stat}</span>
                <p className="text-xs text-stone-500 mt-1">{point.statLabel}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base text-stone-300 font-medium">
            AdForge fixes all three — in under 3 minutes.
          </p>
        </div>
      </div>
    </section>
  );
}
